import clsx from 'clsx';

interface SectionCardProps {
  title?: string;
  subtitle?: string;
  badge?: string;
  children: React.ReactNode;
  className?: string;
}

export function SectionCard({ title, subtitle, badge, children, className }: SectionCardProps) {
  return (
    <section
      className={clsx(
        'bg-[var(--panel-bg)] backdrop-blur-xl border border-[var(--grid-line)] rounded-xl p-8 mb-6',
        className,
      )}
    >
      {(title || badge) && (
        <div className="flex items-center justify-between mb-6">
          <div>
            {title && <h2 className="font-display text-xl">{title}</h2>}
            {subtitle && <p className="text-xs text-daynote-muted mt-1">{subtitle}</p>}
          </div>
          {badge && (
            <span className="text-[10px] tracking-widest uppercase px-2 py-1 rounded bg-daynote-accent/15 text-daynote-accent border border-daynote-accent/30">
              {badge}
            </span>
          )}
        </div>
      )}
      {children}
    </section>
  );
}
